<template>
  <!-- 变更售后公司 -->
  <div>
    <h1 class="item-title">{{ $t('components_contract_change_afterservice.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_afterservice.he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_afterservice.he_tong_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_afterservice.sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_afterservice.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_afterservice.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_afterservice.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_afterservice.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_change_afterservice.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_change_afterservice.shen_qing_xin_xi') }}</h1>
    <div class="stop-rent-tip" v-if="lastDevice.length"><i class="icon icon-tishi"></i><span>{{$t('components_contract_change_afterservice.ji_shen_hao')}} {{lastDevice.join(',')}} {{$t('components_contract_change_afterservice.yxzbzcbgshfwgs')}}</span></div>
    <div class="stop-rent-tip" v-if="lastDeviceEnd.length"><i class="icon icon-tishi"></i><span>{{$t('components_contract_change_afterservice.ji_shen_hao')}} {{lastDevice.join(',')}} ，{{$t('components_contract_change_afterservice.wxzsbzyhtzzcbgshfwgs')}}</span></div>
    <p style="line-height: 30px; font-size: 14px; color: #00afff">{{ $t('components_contract_change_afterservice.zhu') }}：{{ $t('components_contract_change_afterservice.shdyszdcbgqrdxyqkssx') }}。</p>
    <div style="margin-bottom: 30px">
      <custom-table
        ref="customTb1"
        v-model="selectDevice"
        type="checkbox"
        tableCode="changeAfterService"
        :data="dataList"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['newAfterServiceName', 'newDate', 'action']"
      >
        <template slot="newAfterServiceName" slot-scope="scope">
          <custom-select
            width="96%"
            remote
            filterable
            :disabled="model.type === 'watch' || scope.row.isExists"
            v-model="scope.row.newAfterServiceId"
            url="partnerAllService"
            :listener="scope.row.newAfterServiceId"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            :params="{ num:50, keyword: scope.row.newAfterServiceName }"
            @change="onSelectBackOrg($event, scope.row)"
            :filterOptions="scope.row"
            :dataFilter="partnerSelectFilter"
          ></custom-select>
        </template>
        <template slot="newDate" slot-scope="scope">
          <custom-date-picker
            style="width: 98%"
            :disabled="model.type === 'watch' || scope.row.isExists"
            v-model="scope.row.afterServiceEffectTime"
            align="right"
            type="date"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="afterTomorrow"
          ></custom-date-picker>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button :disabled="!scope.row.afterServiceEffectTime || !scope.row.newAfterServiceId || (model.row && model.row.changeState == 10)" type="text" size="mini" @click="onPreview(scope.row)">
            {{ $t('components_contract_change_afterservice.yu_lan_zhang_dan') }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" ref="form" :rules="rules" label-width="auto">
      <el-form-item :label="$t('components_contract_change_afterservice.shen_qing_miao_shu')" prop="changeDesc">
        <el-input type="textarea" :rows="4" :disabled="model.type === 'watch'" :placeholder="$t('components_contract_change_afterservice.qstxsqsm')" v-model="form.changeDesc" style="width: 626px"></el-input>
      </el-form-item>
    </el-form>
    <!-- 预览账单 -->
    <preview-bill-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></preview-bill-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import previewBillDialog from './children/preview_bill_dialog.vue';

export default {
  components: { previewBillDialog },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
        };
      },
    },
  },
  data() {
    return {
      dataList: [],
      detail: {},
      selectDevice: [],
      serviceList: [],
      lastDevice: [],
      lastDeviceEnd: [],
      lastContract: '',
      picker: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      dialogModel: {},
      dialogVisible: false,
      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: [],
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        changeDesc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
  },
  methods: {
    partnerSelectFilter(list, item) {
      return list.filter(t => t.partnerOrgId !== item.oldAfterServiceId);
    },
    // 选择退回地址
    onSelectBackOrg: function (data, row) {
      row.newAfterServiceName = data.partnerName;
    },
    // 预览账单
    onPreview: function (row) {
      this.dialogModel.title = this.$t('components_contract_change_afterservice.yu_lan_zhang_dan');
      this.dialogModel.type = 'change_afterservice';
      // this.dialogModel.row = Object.assign({ changeDate: this.$moment(row.afterServiceEffectTime).format('YYYY-MM-DD') }, this.detail, row);
      this.dialogModel.row = Object.assign({ changeDate: row.afterServiceEffectTime }, this.detail, row);
      this.dialogVisible = true;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        showDeviceType: 1,
        bizState: ['21', '22', '29'],
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.afterServiceEffectTime = '';
          item.oldAfterServiceId = item.oldAfterServiceId;
          item.oldAfterServiceName = item.oldAfterServiceName;
          item.newAfterServiceId = '';
          item.newAfterServiceName = '';
        });
        this.dataList = list;
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.afterServiceEffectTime = row.afterServiceEffectTime;
              item.oldAfterServiceId = row.oldAfterServiceId;
              item.oldAfterServiceName = row.oldAfterServiceName;
              item.newAfterServiceId = row.newAfterServiceId;
              item.newAfterServiceName = row.newAfterServiceName;
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
        // 在原合同时（续租设备处理）
        const list1 = list.filter(t => t.lastBizState && (t.lastBizState < 43));
        if (list1.length > 0) {
          this.lastDeviceEnd = list1.map(f => f.bodyNum);
          this.lastContract = list1[0]['lastContractNo'];
          this.dataList.forEach((item) => {
            item.isExists = this.lastDeviceEnd.includes(item.bodyNum);
          });
        }
        // 在原合同时（续租设备处理）
        const lastDeviceList = list.filter(t => !!t.renewalOrderDeviceId);
        if (lastDeviceList.length > 0) {
          this.lastDevice = lastDeviceList.map(f => f.bodyNum);
          this.dataList.forEach((item) => {
            item.isExists = !!item.renewalOrderDeviceId;
          });
        }
      });
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.selectDevice.length) {
          this.$message.error(this.$t('components_contract_change_afterservice.qxzbgsb'));
          return;
        }
        const hasEmpty = this.selectDevice.find(t => !t.newAfterServiceId || !t.afterServiceEffectTime);
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_change_afterservice.qxzxshgsbgsj'));
          return;
        }
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.selectDevice;
        this.$postJSON(apis.AfterServiceSave, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
